import { render, staticRenderFns } from "./news.page.pug?vue&type=template&id=0ca98686&scoped=true&lang=pug&external"
import script from "./news.page.ts?vue&type=script&lang=js&external"
export * from "./news.page.ts?vue&type=script&lang=js&external"
import style0 from "./news.page.sass?vue&type=style&index=0&id=0ca98686&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca98686",
  null
  
)

export default component.exports